<div fxLayout="column" fxLayoutAlign="center stretch" style="padding: 2% 6vw;" fxLayoutGap="16px">
    <h1>Dashboard</h1>
    <app-recent-activity-card></app-recent-activity-card>
    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="start" fxLayoutGap="16px">
        <app-top-courses-card></app-top-courses-card>
        <app-top-lessons-card></app-top-lessons-card>
        <app-top-users-card></app-top-users-card>
    </div>
</div>